module.exports = "<mat-card>\n   <app-json-form-view\n      [schema]=\"_jsonSchema\"\n      [layout]=\"_jsonLayout\"\n      [data]=\"_jsonData\">\n   </app-json-form-view>\n</mat-card>\n"


//////////////////
// WEBPACK FOOTER
// /builds/cp/frap/t3/planer/src/app/json-form/compc/json-form-cont/json-form-cont.component.html
// module id = ../../../../../src/app/json-form/compc/json-form-cont/json-form-cont.component.html
// module chunks = main